"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var o = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var o__default = /*#__PURE__*/_interopDefaultLegacy(o);

var g=o.css`
  font-size: var(--font-size-small);
  line-height: var(--line-height-large);
`,i=o.css`
  font-size: var(--font-size-regular);
  line-height: var(--line-height-regular);
  letter-spacing: var(--letter-spacing-regular);
`,p=o.css`
  font-size: var(--font-size-medium);
  line-height: var(--line-height-small);
`,c=o.css`
  font-size: var(--font-size-x-x-large);
  line-height: var(--line-height-x-small);
`,h=o.css`
  font-weight: var(--font-weight-bold);
`,m=o.css`
  font-weight: var(--font-weight-semibold);
`,f=o.css`
  font-weight: var(--font-weight-regular);
`,d=o.css`
  letter-spacing: var(--letter-spacing-dense);
`,v=o.css`
  letter-spacing: var(--letter-spacing-spacious);
`,S=i,u="foreground-secondary",x=o__default["default"].p`
  margin: 0;
  ${i}
  ${f}
  ${({$size:e})=>e==="small"&&g}
  ${({$size:e})=>e==="medium"&&p}
  ${({$size:e})=>e==="large"&&c}
  ${({$weight:e})=>e==="bold"&&h}
  ${({$weight:e})=>e==="semibold"&&m}
  ${({$colorToken:e})=>e&&`color: var(--${e});`}
  ${({$letterSpacing:e})=>e==="dense"&&d}
  ${({$letterSpacing:e})=>e==="spacious"&&v}
`,T=({size:e,weight:r,colorToken:s=u,letterSpacing:l,children:n,...a})=>jsxRuntime.jsx(x,{$size:e,$weight:r,$colorToken:s,$letterSpacing:l,...a,children:n}),C=o__default["default"](T)``;var b=o.css`
  margin: 0;
  color: var(--foreground-primary);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-small);
`,P=o__default["default"].h2`
  ${b};
`,F=P;

exports.a = S;
exports.b = u;
exports.c = x;
exports.d = C;
exports.e = b;
exports.f = F;
